import { useEffect, useRef } from 'react';
import { IconCamera, IconCameraOff } from '@tabler/icons-react';
import classes from './CameraPreview.module.css';

interface CameraPreviewProps {
  stream: MediaStream | null;
  error: string | null;
  isActive: boolean;
  className?: string;
}

export function CameraPreview({ stream, error, isActive, className }: CameraPreviewProps) {
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    if (videoRef.current && stream) {
      videoRef.current.srcObject = stream;
    }
  }, [stream]);

  return (
    <div className={`${classes.container} ${className || ''}`}>
      {isActive && stream ? (
        <video
          ref={videoRef}
          autoPlay
          playsInline
          muted
          className={classes.video}
          aria-label="Camera preview"
        />
      ) : (
        <div className={`${classes.placeholder} ${error ? classes.error : ''}`}>
          {error ? (
            <>
              <IconCameraOff size={48} className={classes.icon} />
              <p className={classes.message}>{error}</p>
            </>
          ) : (
            <>
              <IconCamera size={48} className={classes.icon} />
              <p className={classes.message}>Initializng camera...</p>
            </>
          )}
        </div>
      )}
      {!isActive && (
        <div className={classes.badge}>
          <div className={classes.dot} />
          <span>Camera Inactive</span>
        </div>
      )}
    </div>
  );
}

export default CameraPreview;
